export default {
      id: "ic_chance_games-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_chance_games-usage",
      toString: function () {
        return this.url;
      }
    }